import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/lib/language";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Philosophy from "@/components/Philosophy";
import Pillars from "@/components/Pillars";
import ClosingMark from "@/components/ClosingMark";
import Footer from "@/components/Footer";
import Impressum from "@/components/Impressum";
import Datenschutz from "@/components/Datenschutz";

const Home = () => {
  return (
    <main data-testid="home-page" className="bg-resilie-bg text-resilie-ink">
      <Header />
      <Hero />
      <Philosophy />
      <Pillars />
      <ClosingMark />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#FCFBF9",
              color: "#0A0A0A",
              border: "1px solid #E5E5E5",
              borderRadius: 0,
              fontFamily: "'Manrope', sans-serif",
              fontSize: "12px",
              letterSpacing: "0.06em",
            },
            className: "resilie-toast",
          }}
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
